export const PACKAGE_NAME = 'jiraCachingLayer';
export const TEAM_NAME = 'itops-mithril';
export const SEVEN_DAYS_IN_MILLIS = 7 * 24 * 60 * 60 * 1000;
export const CACHE_NAME_PREFIX = 'jira-cache';
